import { createSlice } from '@reduxjs/toolkit';

export const discordLog = createSlice({
  name: 'discordLog',
  initialState: {
    data: [],
  },

  reducers: {
    setDiscordLog: (state, action) => {
      state.data = action.payload;
    },
    addDiscordLog: (state, action) => {
      state.data.push(action.payload);
    },
    clearDiscordLog: (state) => {
      state.data = [];
    },
  },
});

export const { setDiscordLog, addDiscordLog, clearDiscordLog } =
  discordLog.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getDiscordLog = (state) => state.discordLog.data;

export default discordLog.reducer;
